import { Inject, Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe, DecimalPipe } from '@angular/common';

@Pipe({
  name: 'customCurrency',
  standalone: true,
  pure: false,
})
export class CustomCurrencyPipe implements PipeTransform {
  private currencyPipe: CurrencyPipe;

  constructor(@Inject(DecimalPipe) private readonly decimalPipe: DecimalPipe) {
    this.currencyPipe = new CurrencyPipe('en-US');
  }

  public transform(
    value: number | string | null | undefined,
    currencyCode: string = 'EUR',
    format: string = '1.2-2',
    display: string = 'code' // 'code' | 'symbol' | 'symbol-narrow' | boolean,
  ): string | null {
    if (value === null || value === undefined) return '';

    const valueStr = value.toString();

    // Check if the input value has a sign
    const hasSign = valueStr.startsWith('+') || valueStr.startsWith('-');

    const numericValue = Math.abs(Number(valueStr));
    const formattedValue =
      this.decimalPipe.transform(numericValue, format) || '';

    let result = formattedValue;
    if (currencyCode.toUpperCase() === 'SAR') {
      result = `\uE100 ${formattedValue}`; // Riyal using Unicode U+E100
    } else {
      // Use Angular's built-in CurrencyPipe for other currencies
      const currencyResult = this.currencyPipe.transform(
        numericValue,
        currencyCode,
        display,
        format
      );

      if (currencyResult) {
        // Add a space after the symbol if it's directly attached
        return currencyResult.replace(/^(\D+)(\d)/, '$1 $2'); // adds space between symbol and number
      }

      result = currencyResult !== null ? currencyResult : formattedValue;
    }

    return hasSign
      ? valueStr.startsWith('+')
        ? `+ ${result}`
        : `- ${result}`
      : result;
  }
}
